<div class="wrapper w-100">
  <!-- Sidebar -->

  <nav id="sidebar" [ngClass]="status ? 'active' : ''">
      <div class="close-button" type="button" id="sidebarCollapse" (click)="status=!status">
        <span *ngIf="status"><i class="fas fa-angle-right"></i></span>

        <span *ngIf="!status"><i class="fas fa-angle-left"></i></span>
      </div>
      <div class="sidebar-header">
          <h3>{{ 'NavMenu.Contact' | translate}}</h3>
      </div>

      <ul class="list-unstyled components">

        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="assessor">{{ 'ContactAssessor.ContactAssessor' | translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="calamity-disaster">Disaster Relief (Misfortune & Calamity)</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="appointment">{{ 'ContactAssessor.Bookingsv2' | translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="district-office">{{ 'ContactAssessor.District' | translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="officelocations">{{ 'ContactAssessor.OfficeLocations' | translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="publicrecord">{{'PublicRecords.SearchTitle'|translate}}</a>
        </li>


        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="requestspeaker">{{ 'ContactAssessor.RequestSpeaker' | translate}}</a>
        </li>

        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="requestcertificate">{{ 'ContactAssessor.RequestCertificate' | translate}}</a>
        </li>

        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="directory">{{ 'ContactAssessor.Directory' | translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="feedback">{{ 'ContactAssessor.Feedback' | translate}}</a>
        </li>

      </ul>

  </nav>
  <div  id="content">

            <router-outlet></router-outlet>
</div>


</div>
